<template>
  <div class="container">
    <div class="about">
      <div class="row center-xs">
        <div class="col-xs-12 col-sm-4 col-md-5">
            <expandable-image
              class="about-portrait"
              :src="require('@/assets/kaali.jpg')"
              title="Jonna Närhi">
            </expandable-image>
        </div>
        <div class="about-text-container col-xs-12 col-sm-6">
          <p>
            I love using <b>colors</b> and <b>clean lines</b> in a playful way
            with a touch of boldness to create dynamic ensembles.
            Nature and powerful graphic elements are the most
            important sources for my inspiration.
          </p>
          <p>
            I like to bring everyone a <b>flicker of joy</b> in their daily lives by
            designing cheery graphics and products which <b>brighten even the darkest days.</b>
          </p>
          <div class="row center-xs about-extra-row">
            <div class="col-xs-12 col-sm-6 about-extra-block">
              <h2>WORK</h2>
              <div class="separator-small"></div>
              <p>
                2017–Present | <b>Designer</b><br>
                Muurla Design Marketing Oy
              </p>
            </div>
            <div class="col-xs-12 col-sm-6 about-extra-block">
              <h2>EDUCATION</h2>
              <div class="separator-small"></div>
              <p>
                2014–2018 | <b>Degree programme of Design</b>,<br> 
                Turku University of Applied Sciences            
              </p>
            </div>        
          </div>          
        </div>        
      </div>
    </div>
  </div>
</template>

<script>
import ExpandableImage from '@/components/ExpandableImage.vue';

export default {
  name: "About",
  components: {
    ExpandableImage,
  },
  data() {
    return {
      
    }
  }
}
</script>

<style lang="less" scoped>
.separator-small {
    height: 4px;
    width: 20px;
    background-color: var(--accent);
    text-align: center;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 20px;
}
.separator {
  display: none;
  // Small devices (landscape phones, less than 768px)
  @media all and (max-width: @small-devices) {
    display: block;
  }   
}
.image-text {
  margin-top: 20px;
}
.about {
  padding-top: 110px;
    @media all and (max-width: @small-devices) { 
      padding-top: 90px;
    }
}
.about-portrait {
  width: 400px;
  max-width: 100%;
  display: block;
  border-radius: 2px;
  margin-bottom: 40px;
  margin-left: auto;
  margin-right: auto;
  @media all and (max-width: @xs-devices) {
      width: 280px;
  }  
}
.image-text {
  padding: 0 60px 0 60px;
}
.about-text-container {
  padding: 35px 40px 40px 40px;
  p {
    letter-spacing: 1px;
    text-align: left;
    line-height: 1.9rem;
  }
  @media all and (max-width: @medium-devices) {
    padding: 0 40px 40px 40px;
  }
  // Small devices (landscape phones, less than 768px)
  @media all and (max-width: @small-devices) {
    padding: 20px;
    p {
      text-align: center;
    }
    margin-top: 25px;
  }  
}
.separator {
    height: 4px;
    width: 40px;
    background-color: var(--accent);
    text-align: center;
    margin: 0 auto;
    margin-top: 40px;
}
#contact-title {
  margin-top: 0;
  i {
    vertical-align: middle;
    color: var(--accent);
  }
}
.about-extra-row {
  margin-top: 40px;
  @media all and (max-width: @small-devices) { 
    margin-top: 160px;
  }
}
.about-extra-block {
  padding: 20px;
  p {
    letter-spacing: 1px;
    text-align: center;
    line-height: 1.9rem;    
  }
}
</style>
